
const ButtonLoadingSpinner = ({ className, color = "black" }) => {
    return (
        <svg
            className={className}
            xmlns="http://www.w3.org/2000/svg"
            width="119"
            height="119"
            viewBox="0 0 119 119"
            fill="none"
        >
            <circle
                cx="59.5"
                cy="59.5"
                r="51.5"
                stroke={color}
                strokeWidth="15"
                strokeDasharray="226.5 97.1"
                strokeLinecap="round"
                fill="none"
            >
                <animateTransform
                    attributeName="transform"
                    type="rotate"
                    from="0 59.5 59.5"
                    to="360 59.5 59.5"
                    dur="2s"
                    repeatCount="indefinite"
                />
            </circle>
        </svg>
    );
};

export default ButtonLoadingSpinner;